// Página de Perfil que verán los consumidores de contenido
import { useSearchParams, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import PerfilHeader from '../components/PerfilHeader_contenido';
import PerfilImagen from '../components/PerfilImagen';
import PerfilInfo from '../components/PerfilInfo';
import PerfilDescripcion from '../components/PerfilDescripcion';
import PerfilContacto from '../components/PerfilContacto';
import PerfilGaleria from '../components/PerfilGaleria';
import PerfilMultimedia from '../components/PerfilMultimedia';
import BotonesAccion from '../components/BotonesAccion';
import Valoracion from '../components/Valoracion';
import AgendaCalendario from '../components/AgendaCalendario';
import SubirHistoria from '../components/SubirHistoria';
import VerHistorias from '../components/VerHistorias';
import './perfilContenido.css';
import axios from 'axios';
import PerfilVideo from '../components/PerfilVideo';
import PerfilVideoPromo from '../components/PerfilVideoPromo';
import Card from '../components/Card';
import HistoriasPremiumBanner from '../components/HistoriasPremiumBanner';


const PerfilContenidoPage = () => {
  const [perfil, setPerfil] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isPublicAccess, setIsPublicAccess] = useState(true);
  const [isOwnerAccess, setIsOwnerAccess] = useState(false);
  const [isAdminAccess, setIsAdminAccess] = useState(false);
  const [activeTab, setActiveTab] = useState("fotos");
  const [showAgenda, setShowAgenda] = useState(false);
  const [showSubirHistoria, setShowSubirHistoria] = useState(false);
  const [showVerHistorias, setShowVerHistorias] = useState(false);
  const [ultimaHistoria, setUltimaHistoria] = useState(null);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [valoracionPromedio, setValoracionPromedio] = useState('0,0');
  const [premiumListings, setPremiumListings] = useState([]);
  const [premiumOffset, setPremiumOffset] = useState(0);
  const PREMIUM_VISIBLE = 4;
  const [estasSiguiendo, setEstasSiguiendo] = useState(false);
  const [contadorSeguidores, setContadorSeguidores] = useState(0);
  const [showSeguirLoginBox, setShowSeguirLoginBox] = useState(false);
  const [showConfirmDejar, setShowConfirmDejar] = useState(false);
  const [showValoracionOverlay, setShowValoracionOverlay] = useState(false);
  const [valoracionDetalle, setValoracionDetalle] = useState([]);
  const audioRef = useRef(null);
  const [audioReproduciendo, setAudioReproduciendo] = useState(false);
  const [audioActual, setAudioActual] = useState(0);
  const [audioDuracion, setAudioDuracion] = useState(0);
  const formatTime = (segundos) => {
    if (!segundos || isNaN(segundos)) return '0:00';
    const mins = Math.floor(segundos / 60);
    const secs = Math.floor(segundos % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const perfilId = searchParams.get('id');
  const isPublic = searchParams.get('public') === '1';

useEffect(() => {
    axios.get(`${process.env.REACT_APP_PERFILES_URL}/get.php?id=${perfilId}`)
      .then(res => {
        setPerfil(res.data);
      })
      .catch(err => console.error(err));
  }, [perfilId]);

  // Cargar última historia activa
  useEffect(() => {
    if (!perfilId) return;
    axios.get(`${process.env.REACT_APP_HISTORIAS_VIEWER_URL}/get_historias.php?usuario_id=${perfilId}`)
      .then(res => {
        if (res.data.success && res.data.data.length > 0) {
          setUltimaHistoria(res.data.data[res.data.data.length - 1]);
        } else {
          setUltimaHistoria(null);
        }
      })
      .catch(() => setUltimaHistoria(null));
  }, [perfilId]);

// Cargar valoración promedio
  useEffect(() => {
    if (perfilId) {
      const formData = new FormData();
      formData.append('id', perfilId);
    
      axios.post(`${process.env.REACT_APP_VALORACION_URL}/valoracion_publi_promediofinal.php`, formData)
        .then(res => {
          if (res.data.success) {
            setValoracionPromedio(res.data.data.valoracion_promedio);
          }
        })
        .catch(err => {
          console.error('Error al cargar valoración:', err);
          setValoracionPromedio('0,0');
        });

      // Cargar detalle por pregunta
      axios.get(`${process.env.REACT_APP_VALORACION_URL}/get_valoracion_detalle.php?id_perfil=${perfilId}`)
        .then(res => {
          if (res.data.success) {
            setValoracionDetalle(res.data.data);
          }
        })
        .catch(err => console.error('Error al cargar detalle valoración:', err));
    }
  }, [perfilId]);

// useEffect para cargar listings premium
useEffect(() => {
  axios.get(`${process.env.REACT_APP_PERFILES_URL}/get.php`)
    .then(res => {
      let data = res.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch(e) { data = []; }
      }
      if (Array.isArray(data)) {
        setPremiumListings(data.filter(item => item.categoria_plan === 'Premium'));
      }
    })
    .catch(err => console.error('Error cargando premium:', err));
}, []);

// AGREGAR ESTE NUEVO useEffect:
useEffect(() => {
  // Verificar si el usuario tiene sesión activa
  const userToken = localStorage.getItem('userToken');
  setIsUserLoggedIn(!!userToken);
}, []);

// Cargar contador de seguidores y verificar si el viewer ya sigue este perfil
useEffect(() => {
  if (!perfilId) return;
  const userId = localStorage.getItem('userId');
  const url = userId
    ? `${process.env.REACT_APP_SEGUIDOS_URL}/get_seguidores.php?id=${perfilId}&id_viewer=${userId}`
    : `${process.env.REACT_APP_SEGUIDOS_URL}/get_seguidores.php?id=${perfilId}`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setContadorSeguidores(data.total);
        setEstasSiguiendo(data.ya_siguiendo);
      }
    })
    .catch(err => console.error('Error al cargar seguidores:', err));
}, [perfilId]);


  const handleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

const showMessage = (message, isSuccess = true) => {
    console.log(message, isSuccess);
  };

const handleSeguir = async () => {
    // Si no está logueado, mostrar banner
    if (!isUserLoggedIn) {
      setShowSeguirLoginBox(true);
      return;
    }

    // Si ya está siguiendo, mostrar confirmación para dejar de seguir
    if (estasSiguiendo) {
      setShowConfirmDejar(true);
      return;
    }

try {
      const userId = localStorage.getItem('userId');
      const formData = new FormData();
      formData.append('ID_U_viewer', userId);
      formData.append('ID_Perfil', perfilId);

      const response = await fetch(`${process.env.REACT_APP_SEGUIDOS_URL}/seguir.php`, {
        method: 'POST',
        body: formData
      });

      let data = {};
      try {
        data = await response.json();
      } catch (jsonErr) {
        // Si el JSON falla pero la llamada HTTP fue exitosa, asumir éxito
        if (response.ok) {
          setEstasSiguiendo(true);
          setContadorSeguidores(prev => prev + 1);
        }
        return;
      }

      if (data.success) {
        setEstasSiguiendo(true);
        setContadorSeguidores(prev => prev + 1);
      } else if (data.ya_siguiendo) {
        setEstasSiguiendo(true);
      }
    } catch (err) {
      console.error('Error al seguir:', err);
    }
  };

  const handleDejarSeguir = async () => {
    try {
      const userId = localStorage.getItem('userId');
      const formData = new FormData();
      formData.append('ID_U_viewer', userId);
      formData.append('ID_Perfil', perfilId);

      const response = await fetch(`${process.env.REACT_APP_SEGUIDOS_URL}/dejar_seguir.php`, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();

      if (data.success) {
        setEstasSiguiendo(false);
        setContadorSeguidores(prev => Math.max(0, prev - 1));
        setShowConfirmDejar(false);
      }
    } catch (err) {
      console.error('Error al dejar de seguir:', err);
    }
  };

  const saveData = async (data) => {
    try {
      const response = await axios.post('save_profile.php', data);
      if (response.data.success) {
        showMessage('Cambio guardado con éxito', true);
        return true;
      } else {
        showMessage('Error al guardar: ' + response.data.message, false);
        return false;
      }
    } catch (error) {
      console.error('Error:', error);
      showMessage('Error al conectar con el servidor', false);
      return false;
    }
  };

  const handleTabChange = (tab) => {
    console.log('Cambiando a tab:', tab);
    setActiveTab(tab);
  };

  const handleVideoSave = async (videoData) => {
    try {
      console.log('Guardando video:', videoData);
      const result = await saveData({
        ...videoData,
        section: 'videos'
      });
      
      if (result) {
        // Actualizar el estado del perfil si es necesario
      }
      
      return result;
    } catch (error) {
      console.error('Error al guardar video:', error);
      showMessage('Error al guardar el video', false);
      return false;
    }
  };

const handleConfigurAgenda = () => {
  setShowAgenda(true);
};

const handleCloseAgenda = () => {
  setShowAgenda(false);
};

  if (!perfil) return <div>Cargando perfil...</div>;

if (showAgenda) {
  return (
    <AgendaCalendario 
      usuarioId={perfil?.id || 1}
      onClose={handleCloseAgenda}
      modoSoloLectura={false}
      tituloPersonalizado='Configurar Mi Agenda'
    />
  );  
}

  // AGREGAR ESTAS 3 LÍNEAS AQUÍ ⬇️
  const userName = localStorage.getItem('userName');
  const userEmail = localStorage.getItem('userEmail');

  return (
    <div className={`perfil-container ${isEditMode ? 'edit-mode' : ''}`}>
      {/* Logo superior */}
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`} alt="Ulalaaa Logo" className="main-logo" />
      </div>

      {/* Banner de sesión de usuario (solo si está logueado) */}
      {isUserLoggedIn && (
        <div className="user-session-banner">
          <div className="session-info">
            <i className="fas fa-user-circle"></i>
            <div className="session-text">
              <span className="session-label">Inicio sesión:</span>
              <span className="session-user">{userName || userEmail}</span>
            </div>
          </div>
          <button 
            className="btn-mi-perfil"
            onClick={() => {
              navigate('/sesion_viewer');
            }}
          >
            Mi Perfil
          </button>
          <button 
            className="btn-cerrar-sesion"
            onClick={() => {
              // Limpiar localStorage
              localStorage.removeItem('userToken');
              localStorage.removeItem('userId');
              localStorage.removeItem('userName');
              localStorage.removeItem('userEmail');
              localStorage.removeItem('returnToProfile');
        
              // Actualizar estado
              setIsUserLoggedIn(false);
        
              // Redirigir a Home
              navigate('/');
            }}
          >
            Cerrar Sesión
          </button>
        </div>
      )}
      {/* ⬆️ TERMINA AQUÍ */}

{/* Banner con Historias Premium (componente real, igual que en Perfil.jsx) */}
      <HistoriasPremiumBanner />

      {/* Strip de cards Premium */}
      {premiumListings.length > 0 && (
        <div className="premium-strip-section">
          <div className="premium-strip-label">PREMIUM</div>
          <div className="premium-strip-row">
            <div className="premium-strip-cards">
              {premiumListings.slice(premiumOffset, premiumOffset + PREMIUM_VISIBLE).map(item => (
                <Card key={item.id} data={item} />
              ))}
            </div>
            {premiumOffset + PREMIUM_VISIBLE < premiumListings.length && (
              <button
                className="premium-strip-flecha"
                onClick={() => setPremiumOffset(prev => prev + 1)}
              >
                ➡
              </button>
            )}
          </div>
        </div>
      )}

      {/* Mensaje informativo para propietarios */}
      {isOwnerAccess && (
        <div className="owner-info">
          <i className="fas fa-user-check"></i>
          Estás viendo tu propio perfil. Puedes editarlo haciendo clic en "EDITAR MI PERFIL".
        </div>
      )}

      {/* Mensaje de guardado */}
      {!isPublicAccess && (
        <div className="save-message" id="saveMessage" style={{display: 'none'}}>
          Cambios guardados con éxito
        </div>
      )}

      <div className="container">
{/* Historias del perfil - sobre verificado */}
        <div className="perfil-historias-row">
          <div className="historias-premium-label">HISTORIAS</div>
          <div 
            className={`historia-circulo-wrapper ${ultimaHistoria ? 'historia-con-contenido' : 'historia-sin-contenido'}`}
            onClick={() => setShowVerHistorias(true)}
            style={{ cursor: 'pointer' }}
          >
            {ultimaHistoria ? (
              ultimaHistoria.tipo === 'foto' ? (
                <img
                  src={`${process.env.REACT_APP_UPLOADS_URL}/ID_${perfilId}/historias/${ultimaHistoria.archivo}`}
                  alt="Historia"
                  className="historia-circulo historia-circulo-perfil historia-preview-img"
                />
              ) : (
                <video
                  src={`${process.env.REACT_APP_UPLOADS_URL}/ID_${perfilId}/historias/${ultimaHistoria.archivo}`}
                  className="historia-circulo historia-circulo-perfil historia-preview-img"
                  muted
                  playsInline
                />
              )
            ) : (
              <div className="historia-circulo historia-circulo-perfil historia-vacia">
                <span>Sin historias</span>
              </div>
            )}
          </div>
        </div>

        {/* Badge de verificación */}
        <div className="profile-verified-badge">
          <i className="fas fa-check-circle"></i>
          <span>Verificado</span>
        </div>
<PerfilHeader 
  perfil={perfil}
  valoracionPromedio={valoracionPromedio}
  contadorSeguidores={contadorSeguidores}
  onValoracionClick={() => setShowValoracionOverlay(true)}
  videoPromo={
    <PerfilVideoPromo 
      perfil={perfil}
      isEditMode={isEditMode}
      onSave={saveData}
    />
  }
>
</PerfilHeader>

{/* PANEL DE CONTROL */}
<div className="panel-control-container">
  <div className="panel-control-title">PANEL CONTROL</div>
  <div className="panel-control-buttons">
    <button 
      className="btn-panel-control btn-editar-agenda"
      onClick={handleConfigurAgenda}
    >
      <i className="fas fa-calendar-check"></i> EDITAR AGENDA
    </button>
    <button 
      className="btn-panel-control btn-subir-historia"
      onClick={() => setShowSubirHistoria(true)}
    >
      <i className="fas fa-camera"></i> SUBIR HISTORIA
    </button>
  </div>
</div>

{/* Botones de acción principales */}
<div className="action-buttons-container">
  <a 
    href={`tel:${perfil.telefono?.replace(/[+\s-]/g, '') || perfil.whatsapp?.replace(/[+\s-]/g, '') || ''}`}
    className="btn-action btn-llamar"
  >
    <i className="fas fa-phone"></i> Llamar
  </a>
  <a 
    href={`https://wa.me/${perfil.whatsapp?.replace(/[+\s-]/g, '') || perfil.telefono?.replace(/[+\s-]/g, '') || ''}`}
    target="_blank"
    rel="noopener noreferrer"
    className="btn-action btn-contactar"
  >
    <i className="fab fa-whatsapp"></i> Contactar
  </a>
  {perfil.telegram && (
    <a 
      href={`https://t.me/${perfil.telegram?.replace(/[+\s-]/g, '')}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-action btn-telegram"
    >
      <i className="fab fa-telegram-plane"></i> Telegram
    </a>
  )}
</div>
                
        {/* Información de contacto */}
        <div className="profile-contact">
          <div className={`contact-item ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
            <i className="fab fa-whatsapp"></i>
            <div className="contact-text">
              <h4>WhatsApp</h4>
              <p>{perfil.whatsapp || perfil.telefono || ''}</p>
            </div>
          </div>
          
          <div className={`contact-item ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
            <i className="fas fa-map-marker-alt"></i>
            <div className="contact-text">
              <h4>Ubicación</h4>
              <p>{perfil.ubicacion}</p>
            </div>
          </div>
          
          <div className={`contact-item ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
            <i className="fas fa-clock"></i>
            <div className="contact-text">
              <h4>Disponibilidad</h4>
              <p>{perfil.disponibilidad}</p>
            </div>
          </div>
        </div>
        
        {/* Descripción */}
        <div className={`profile-about ${(isAdminAccess || isOwnerAccess) ? 'editable' : ''}`}>
          <h3>Descripción</h3>
          <p>{perfil.descripcion}</p>
        </div>
        
        {/* Audio de presentación */}
        <div className="profile-audio">
          <div className="audio-item">
            <i className="fas fa-microphone"></i>
            <div className="audio-text">
              <h4>Audio de presentación</h4>
              <div className="audio-player">
<audio
  ref={audioRef}
  onTimeUpdate={() => setAudioActual(audioRef.current.currentTime)}
  onLoadedMetadata={() => setAudioDuracion(audioRef.current.duration)}
  onEnded={() => setAudioReproduciendo(false)}
  style={{ display: 'none' }}
>
  <source src={perfil.audio
  ? `${process.env.REACT_APP_UPLOADS_URL}/ID_${perfil.id}/${perfil.audio}?v=${perfil.id}`
  : '#'} type="audio/ogg" />
  Tu navegador no soporta el elemento de audio.
</audio>
<div className="audio-controls-custom">
  <button type="button" className="audio-play-btn" onClick={() => {
    if (audioRef.current.paused) { audioRef.current.play(); setAudioReproduciendo(true); }
    else { audioRef.current.pause(); setAudioReproduciendo(false); }
  }}>
    {audioReproduciendo ? '❚❚' : '▶'}
  </button>
  <span className="audio-tiempo">{formatTime(audioActual)}</span>
  <input
    type="range"
    className="audio-progreso"
    min="0"
    max={audioDuracion || 0}
    value={audioActual}
    onChange={(e) => { audioRef.current.currentTime = e.target.value; setAudioActual(Number(e.target.value)); }}
  />
  <span className="audio-tiempo">{formatTime(audioDuracion)}</span>
</div>
              </div>
            </div>
          </div>
        </div>

        {/* Navegación de tabs para Fotos y Videos */}
        <div className="media-tabs">
          <div className="tab-navigation">
            <button 
              className={`tab-button ${activeTab === 'fotos' ? 'active' : ''}`}
              onClick={() => handleTabChange('fotos')}
            >
              <i className="fas fa-image"></i> Fotos
            </button>
            <button 
              className={`tab-button ${activeTab === 'videos' ? 'active' : ''}`}
              onClick={() => handleTabChange('videos')}
            >
              <i className="fas fa-video"></i> Videos
            </button>
          </div>
        </div>
        
        {/* Sección de Fotos */}
        {activeTab === 'fotos' && (
          <PerfilImagen 
            data={perfil}
            isEditMode={isEditMode}
            onSave={saveData}
          />
        )}
        
        {/* Sección de Videos */}
        {activeTab === 'videos' && (
          <PerfilVideo 
            perfil={perfil}
            isEditMode={isEditMode}
            onSave={handleVideoSave}
          />
        )}
      
        
{/* Overlay Valoración por pregunta */}
      {showValoracionOverlay && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
          onClick={() => setShowValoracionOverlay(false)}
        >
          <div
            style={{
              background: 'white', borderRadius: '12px', padding: '30px',
              maxWidth: '500px', width: '90%', maxHeight: '80vh', overflowY: 'auto'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ fontFamily: 'Arial Black', color: '#53120C', marginBottom: '20px', textAlign: 'center' }}>
              DETALLE VALORACIÓN
            </h2>
            {valoracionDetalle.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666' }}>Sin valoraciones aún.</p>
            ) : (
              valoracionDetalle.map(item => (
                <div key={item.id} style={{ marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '12px' }}>
                  <p style={{ fontFamily: 'Arial', fontSize: '14px', color: '#333', marginBottom: '6px' }}>
                    {item.pregunta}
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                      background: parseFloat(item.promedio) >= 4 ? '#00C853' : parseFloat(item.promedio) >= 2.5 ? '#FFA500' : '#CC0000',
                      color: 'white', borderRadius: '6px', padding: '4px 12px',
                      fontFamily: 'Arial Black', fontSize: '16px', fontWeight: '900'
                    }}>
                      {item.promedio}
                    </div>
                    <span style={{ fontSize: '12px', color: '#999' }}>{item.total_votos} voto(s)</span>
                  </div>
                </div>
              ))
            )}
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button
                onClick={() => setShowValoracionOverlay(false)}
                style={{
                  background: '#53120C', color: 'white', border: 'none',
                  padding: '10px 30px', borderRadius: '8px', cursor: 'pointer',
                  fontFamily: 'Arial Black', fontSize: '16px', fontWeight: '900'
                }}
              >
                CERRAR
              </button>
            </div>
          </div>
        </div>
      )}

{/* Botón de regreso */}
        <button 
          className="back-button"
          onClick={() => navigate('/')}
          >
          Volver al inicio
        </button>        
      </div>

{/* Overlay login para Seguir */}
      {showSeguirLoginBox && (
        <div className="seguir-login-overlay" onClick={() => setShowSeguirLoginBox(false)}>
          <div className="login-required-box" onClick={e => e.stopPropagation()}>
            <i className="fas fa-lock"></i>
            <h3>Para Seguir debes iniciar sesión</h3>
            <button
              className="btn-inicia-sesion"
              onClick={() => {
                localStorage.setItem('returnToProfile', perfilId);
                navigate('/acceso_viewer');
              }}
            >
              INICIA SESIÓN
            </button>
          </div>
        </div>
      )}

      {/* Overlay confirmación dejar de seguir */}
      {showConfirmDejar && (
        <div className="seguir-login-overlay" onClick={() => setShowConfirmDejar(false)}>
          <div className="confirm-dejar-box" onClick={e => e.stopPropagation()}>
            <i className="fas fa-user-minus"></i>
            <h3>¿Deseas dejar de seguir a <span>{perfil.nombre}</span>?</h3>
            <div className="confirm-dejar-botones">
              <button className="btn-confirmar-si" onClick={handleDejarSeguir}>
                SÍ, DEJAR DE SEGUIR
              </button>
              <button className="btn-confirmar-no" onClick={() => setShowConfirmDejar(false)}>
                NO, CANCELAR
              </button>
            </div>
          </div>
        </div>
      )}
{/* MODAL SUBIR HISTORIA */}
      {showSubirHistoria && (
        <SubirHistoria
          usuarioId={perfil?.id}
          onClose={() => setShowSubirHistoria(false)}
        />
      )}

{/* MODAL VER HISTORIAS */}
      {showVerHistorias && (
        <VerHistorias
          usuarioId={perfil?.id}
          nombrePerfil={perfil?.nombre}
          fotoPerfil={perfil?.fotos ? `${process.env.REACT_APP_UPLOADS_URL}/ID_${perfil?.id}/${perfil.fotos}` : null}
          esCreador={true}
          onClose={() => setShowVerHistorias(false)}
          onSubirHistoria={() => {
            setShowVerHistorias(false);
            setShowSubirHistoria(true);
          }}
        />
)}

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default PerfilContenidoPage;